import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, Row, Col, Label, Input, FormGroup } from "reactstrap";
import GeneralButton from "../button/GeneralButton";
import { triggerDnhImport } from "../../api/dnhCategories.api";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { Select } from "antd";

const ImportDnhProductsModal = ({ modal, toggle }) => {
    const [manufacturer, setManufacturer] = useState(null);

    const [syncToAlgolia, setSyncToAlgolia] = useState(true);
    const [loading, setLoading] = useState(false);

    const { all_manufacturers, all_allowed_manufacturers } = useSelector((state) => state.redux);

    const manufacturersMap = all_manufacturers?.reduce((acc, mfg) => {
        acc[mfg._id] = mfg.name;
        return acc;
    }, {}) || {};

    useEffect(() => {
        if (!manufacturer && all_allowed_manufacturers?.length > 0) {
            const firstEnabled = all_allowed_manufacturers.find(i => i.enabled);
            if (firstEnabled) {
                setManufacturer(firstEnabled.dnhVendorName);
            }
        }
    }, [all_allowed_manufacturers, manufacturer]);

    const handleImport = async () => {
        if (!manufacturer) {
            toast.error("Please select a manufacturer");
            return;
        }

        setLoading(true);
        const loadingToast = toast.loading(`Triggering DNH Import for ${manufacturer}...`);

        await triggerDnhImport(manufacturer, syncToAlgolia, (res) => {
            toast.dismiss(loadingToast);
            setLoading(false);
            if (res.status === 200) {
                toast.success(res.data.message || "DNH Import triggered successfully!");
                toggle();
            } else {
                toast.error(res.message || "Failed to trigger DNH Import");
            }
        });
    };

    return (
        <Modal isOpen={modal} toggle={toggle} centered>
            <ModalHeader toggle={toggle}>Trigger DNH Product Import</ModalHeader>
            <ModalBody>
                <Row>
                    <Col md={12}>
                        <FormGroup>
                            <Label className="fw-bold">Manufacturer (DNH Vendor)</Label>
                            <Select
                                showSearch
                                style={{ width: '100%' }}
                                placeholder="Select a manufacturer"
                                optionFilterProp="children"
                                value={manufacturer}
                                onChange={(val) => setManufacturer(val)}
                                size="large"
                            >
                                {all_allowed_manufacturers?.filter(i => i.enabled)?.map((item) => (
                                    <Select.Option key={item._id} value={item.dnhVendorName}>
                                        {item.dnhVendorName} ({manufacturersMap[item.manufacturerId] || item.manufacturerId})
                                    </Select.Option>
                                ))}
                            </Select>
                        </FormGroup>
                    </Col>
                    <Col md={12} className="mt-2">
                        <FormGroup check>
                            <Label check>
                                <Input
                                    type="checkbox"
                                    checked={syncToAlgolia}
                                    onChange={(e) => setSyncToAlgolia(e.target.checked)}
                                />{' '}
                                Sync to Algolia
                            </Label>
                        </FormGroup>
                    </Col>
                </Row>
                <div className="d-flex justify-content-end mt-4">
                    <GeneralButton
                        title={"Start Import"}
                        className={"blue-button"}
                        width={"150px"}
                        handleClick={handleImport}
                        disabled={loading}
                    />
                </div>
            </ModalBody>
        </Modal>
    );
};

export default ImportDnhProductsModal;
